import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { DateTools } from '@treezor/design-system';

import { IPeriod, IPeriodField, periodBases } from '@/ui-kit/table-filters/filters.type';
import { isBetween, isFrom, isTo } from '@/ui-kit/table-filters/PeriodFilter';
import { IAllCardsFiltersFormFields } from '@/features/cards/store/types/agent-card.types';

export function mapAllCardsCreated(value) {
  if (isFrom(value) && value.base === periodBases.ON) {
    const toDate = new Date(value.from).getTime();
    return {
      createdDateFrom: value.from,
      createdDateTo: DateTools.format(new Date(toDate + 86399900), 'api-date-time'),
    };
  } else if (isFrom(value) && value.base === periodBases.AFTER) {
    return { createdDateFrom: value.from };
  } else if (isTo(value)) {
    return { createdDateTo: DateTools.format(new Date(value.to).getTime() + 86399900, 'api-date-time') };
  } else if (isBetween(value)) {
    return {
      createdDateFrom: value.from,
      createdDateTo: DateTools.format(new Date(value.to).getTime() + 86399900, 'api-date-time'),
    };
  }
}

export function useAllCardsCreatedField(methods: UseFormReturn<IAllCardsFiltersFormFields>, onChange): IPeriodField {
  const handleCreatedDateChange = useCallback(
    (value: IPeriod) => {
      if (value.base === null && value.from === null && value.to === null) {
        methods.reset();
        onChange();
        return;
      }

      const currentValue = methods.getValues('createdDate');
      const newValue = Object.keys(value).reduce<IPeriod>((prev, current) => {
        return { ...prev, [current]: value[current] === null ? currentValue[current] : value[current] };
      }, {} as IPeriod);
      methods.setValue('createdDate', newValue);

      if (isFrom(newValue) || isTo(newValue) || isBetween(newValue)) {
        onChange();
      }
    },
    [onChange, methods],
  );

  const createdDateValue = methods.watch('createdDate');

  return { value: createdDateValue, handleChange: handleCreatedDateChange };
}
